import React, { useEffect, useState } from 'react';
import { SalesSummaryModalView } from './SalesSummaryModalView';


const SalesSummaryModal = ({ brand, merchoidSales, aaaSales, stock, setShowSalesModal, groupBy }) => {
    const [stateStockTable, setStateStockTable] = useState()
    const [selectedSales, setSelectedSales] = useState('All Sales');
    const [selectedStock, setSelectedStock] = useState('All Stock');
    const [sortConfig, setSortConfig] = useState(null);
    const [stockArrayState, setStockArrayState] = useState([])
    const [totals, setTotals] = useState({
        merchoidQty: 0,
        aaaQty: 0,
        merchoidCostPrice: 0,
        aaaCostPrice: 0,
        aaaSalesQty: 0,
        aaaSalesValue: 0,
        merchoidSalesQty: 0,
        merchoidSalesValue: 0,
        merchoidStockValue: 0,
        aaaStockValue: 0,
        combinedStockValue: 0,
        combinedSalesValue: 0,
    })



    function getRatioColor(ratio) {
        if (ratio === 0) {
            return 'green';
        } else if (ratio === 9999) {
            return 'red';
        } else {
            // Compute a color code between green (0, 128, 0) and red (255, 0, 0).
            // Normalize ratio to the range 0-1
            let normalizedRatio = Math.min(Math.max(ratio, 0), 200) / 200;

            // Interpolate between green and red
            let r = Math.round(255 * normalizedRatio);
            let g = Math.round(128 * (1 - normalizedRatio));
            return 'rgb(' + r + ',' + g + ',0)';
        }
    }



    useEffect(() => {
        const stockArray = createStockArray();

        if (sortConfig !== null) {
            stockArray.sort((a, b) => {
                if (sortConfig.key === 'productTitle') {
                    // This block is for string values
                    if (a[sortConfig.key] < b[sortConfig.key]) {
                        return sortConfig.direction === 'ascending' ? -1 : 1;
                    }
                    if (a[sortConfig.key] > b[sortConfig.key]) {
                        return sortConfig.direction === 'ascending' ? 1 : -1;
                    }
                    return 0;
                } else {
                    // This block is for numeric values
                    const aValue = parseFloat(a[sortConfig.key]);
                    const bValue = parseFloat(b[sortConfig.key]);
                    return sortConfig.direction === 'ascending' ? aValue - bValue : bValue - aValue;
                }
            });
        }
        setStockArrayState(stockArray)

        const totals = {
            merchoidQty: 0,
            aaaQty: 0,
            merchoidCostPrice: 0,
            aaaCostPrice: 0,
            aaaSalesQty: 0,
            aaaSalesValue: 0,
            merchoidSalesQty: 0,
            merchoidSalesValue: 0,
            merchoidStockValue: 0,
            aaaStockValue: 0,
            combinedStockValue: 0,
            combinedSalesValue: 0,
        };



        // Calculate totals.
        for (const row of stockArray) {
            totals.merchoidQty += row.merchoidQty;
            totals.aaaQty += row.aaaQty;
            totals.merchoidCostPrice += row.merchoidCostPrice;
            totals.aaaCostPrice += row.aaaCostPrice;
            totals.aaaSalesQty += row.aaaSalesQty;
            totals.aaaSalesValue += row.aaaSalesValue;
            totals.merchoidSalesQty += !isNaN(row.merchoidSalesQty) ? row.merchoidSalesQty : 0
            totals.merchoidSalesValue +=  !isNaN(row.merchoidSalesValue) ? row.merchoidSalesValue : 0
            totals.merchoidStockValue += row.merchoidStockValue;
            totals.aaaStockValue += row.aaaStockValue;
            totals.combinedStockValue += row.combinedStockValue;
            totals.combinedSalesValue += row.combinedSalesValue;
        }

        setTotals(totals)





        setStateStockTable(
            stockArray.map(
                ({
                    sku,
                    productTitle,
                    merchoidQty,
                    aaaQty,
                    merchoidCostPrice,
                    aaaCostPrice,
                    aaaSalesQty,
                    aaaSalesValue,
                    merchoidSalesQty,
                    merchoidSalesValue,
                    merchoidStockValue,
                    aaaStockValue,
                    combinedStockValue,
                    combinedSalesValue,
                    aggregated,
                    salesSource,
                    ratio,
                }) => {




                    return (
                        <tr
                            key={sku}
                            style={{
                                backgroundColor: salesSource === 'aaa' ? 'rgba(255, 173, 87, 0.3)' : 'inherit',
                            }}
                        >
                            <td>{sku}</td>
                            <td>
                                {productTitle.replace(/\([^()]*size[^()]*\)/gi, '')}{' '}
                                {aggregated && <strong>Aggregated</strong>}
                            </td>
                            {(selectedStock === 'All Stock' || selectedStock === 'Merchoid Stock') && (
                                <>
                                    <td>{merchoidQty}</td>
                                    <td>
                                        £
                                        {merchoidCostPrice
                                            ? merchoidCostPrice
                                            : merchoidSalesValue / merchoidSalesQty
                                                ? (merchoidSalesValue / merchoidSalesQty).toFixed(2)
                                                : 0}
                                    </td>
                                    <td>£{merchoidStockValue.toFixed(2)}</td>
                                </>
                            )}
                            {(selectedStock === 'All Stock' || selectedStock === 'AAA Stock') && (
                                <>
                                    <td>{aaaQty}</td>
                                    <td>£{aaaCostPrice}</td>
                                    <td>£{aaaStockValue.toFixed(2)}</td>
                                </>
                            )}
                            {(selectedSales === 'Merchoid Sales' || selectedSales === 'All Sales') && (
                                <>
                                    <td>{merchoidSalesQty}</td>
                                    <td>£{merchoidSalesValue ? merchoidSalesValue.toFixed(2) : 0}</td>
                                </>
                            )}
                            {(selectedSales === 'AAA Sales' || selectedSales === 'All Sales') && (
                                <>
                                    <td>{aaaSalesQty}</td>
                                    <td>£{aaaSalesValue.toFixed(2)}</td>
                                </>
                            )}
                            {selectedSales === 'All Sales' && <td>£{combinedSalesValue.toFixed(2)}</td>}
                            {selectedStock === 'All Stock' && <td>£{combinedStockValue.toFixed(2)}</td>}
                            <td style={{ backgroundColor: getRatioColor(ratio) }}>{ratio.toFixed(2)}x</td>
                        </tr>
                    );
                }
            )
        );




    }, [selectedStock, selectedSales, sortConfig])

    const requestSort = (key) => {
        let direction = 'ascending';
        if (sortConfig && sortConfig.key === key && sortConfig.direction === 'ascending') {
            direction = 'descending';
        }
        setSortConfig({ key, direction });
    };


    function createStockArray() {
        const aggregatedStock = aggregateStockByParentId();
        const aggregatedSales2 = aggregateSalesByParentId();

        return Object.entries(aggregatedStock).map(([parentId, stockItem]) => {
            const salesItem = aggregatedSales2[parentId] || { merchoidSalesQty: 0, merchoidSalesValue: 0, aaaSalesQty: 0, aaaSalesValue: 0 };
            const { productTitle, merchoidQty, merchoidCostPrice, aggregated, sku, aaaQty, aaaCostPrice } = stockItem;
            const { merchoidSalesQty, merchoidSalesValue, aaaSalesQty, aaaSalesValue, salesSource } = salesItem;
            const merchoidStockValue = merchoidCostPrice * merchoidQty || 0
            const aaaStockValue = aaaCostPrice * aaaQty || 0
            const combinedStockValue = (aaaCostPrice * aaaQty) + (merchoidCostPrice * merchoidQty) || 0
            const combinedSalesValue = parseFloat(aaaSalesValue + merchoidSalesValue) || 0



            let stockValue = 0
            let salesValue = 0
            //sales
            if (selectedSales === 'All Sales') {
                salesValue = combinedSalesValue
            } else if (selectedSales === 'Merchoid Sales') {
                salesValue = merchoidSalesValue
            } else if (selectedSales === 'AAA Sales') {
                salesValue = aaaSalesValue
            }
            //stock
            if (selectedStock === 'All Stock') {
                stockValue = combinedStockValue
            } else if (selectedStock === 'Merchoid Stock') {
                stockValue = merchoidStockValue
            } else if (selectedStock === 'AAA Stock') {
                stockValue = aaaStockValue
            }

            let ratio;

            // Check if salesValue is zero to avoid division by zero
            if (salesValue === 0) {
                // If stockValue is also zero, the ratio should be 0
                // Otherwise, stockValue is non-zero and divided by zero, which is infinity, set it to 9999
                ratio = (stockValue === 0) ? 0 : 9999;
            } else {
                // If salesValue is not zero, perform the division
                let tempRatio = stockValue / salesValue;

                // If the division result is NaN (which should not occur with this check, but just in case)
                ratio = isNaN(tempRatio) ? 0 : tempRatio;
            }


            return {
                productTitle, merchoidQty, merchoidCostPrice, merchoidSalesQty, aaaSalesQty, aaaSalesValue, merchoidSalesValue, merchoidStockValue, aaaStockValue, combinedStockValue, combinedSalesValue, aggregated, sku, salesSource, aaaQty, aaaCostPrice, ratio
            };
        });
    }


    useEffect(() => {
        const handleKeyDown = (event) => {
            if (event.key === 'Escape') {
                setShowSalesModal(false);
            }
        };

        document.addEventListener('keydown', handleKeyDown);
        return () => {
            document.removeEventListener('keydown', handleKeyDown);
        };
    }, [setShowSalesModal]);


    function aggregateSalesByParentId() {
        const aggregatedSales = {};

        merchoidSales.forEach((sale) => {
            const sku = sale.sku;
            const product = stock.find((item) => item.id === sku);

            if (product) {
                const parentId = product.parentId || sku; // Fall back to the SKU if there's no parentId

                if (!aggregatedSales[parentId]) {
                    aggregatedSales[parentId] = {
                        productTitle: product.productName,
                        merchoidSalesQty: 0,
                        merchoidSalesValue: 0,
                        aaaSalesQty: 0,
                        aaaSalesValue: 0,
                        parentId: product.parentId,
                        sku: product.sku
                    };
                }

                const productCostPrice = product.productCost; // Get the cost price from the stock item
                aggregatedSales[parentId].merchoidSalesQty += sale.qty;
                aggregatedSales[parentId].merchoidSalesValue += productCostPrice * sale.qty; // Use productCostPrice instead of sale.costPrice

            }
        });

        aaaSales.forEach((sale) => {
            const sku = sale.sku;
            const product = stock.find((item) => item.id === sku);

            if (product) {
                const parentId = product.parentId || sku; // Fall back to the SKU if there's no parentId

                if (!aggregatedSales[parentId]) {
                    aggregatedSales[parentId] = {
                        aaaSalesQty: 0,
                        aaaSalesValue: 0,
                        parentId: product.parentId,
                    };
                }

                //const productCostPrice = product.productCost; // Get the cost price from the stock item
                aggregatedSales[parentId].aaaSalesQty += sale.qty;
                aggregatedSales[parentId].aaaSalesValue += parseFloat(product.aaaCostPrice) * parseFloat(sale.qty);


            }
        });

        return aggregatedSales;
    }


    function aggregateStockByParentId() {
        const aggregatedStock = {};
        let filteredStock = []
        if (brand === 'All Items') {
            filteredStock = stock
        } else {
            filteredStock = stock.filter(item => item[groupBy] === brand)
        }
        filteredStock.forEach((product) => {
            const parentId = product.parentId;
            if (parentId !== "") {
                if (!aggregatedStock[parentId]) {
                    aggregatedStock[parentId] = {
                        sku: product.id,
                        parentId: product.parentId,
                        productTitle: product.productName,
                        merchoidQty: 0,
                        merchoidCostPrice: product.productCost,
                        aaaQty: 0,
                        aaaCostPrice: product.aaaCostPrice,
                        aggregated: true,
                    };
                }

                const qtyByDate = product.qtyByDate;
                const latestQty = qtyByDate.length >= 1 ? qtyByDate[qtyByDate.length - 1][1] : 0
                aggregatedStock[parentId].merchoidQty += latestQty;

                //add aaa stock
                const aaaQtyByDate = product.aaaQtyByDate;
                const latestAaaQty = aaaQtyByDate.length >= 1 ? aaaQtyByDate[aaaQtyByDate.length - 1][1] : 0
                aggregatedStock[parentId].aaaQty += latestAaaQty;

            } else {
                // Handle products without parent IDs
                aggregatedStock[product.id] = {
                    sku: product.id,
                    parentId: product.parentId,
                    productTitle: product.productName,
                    merchoidQty: product.qtyByDate && product.qtyByDate.length >= 1 ? product.qtyByDate[product.qtyByDate.length - 1][1] : 0,
                    merchoidCostPrice: product.productCost,
                    aaaQty: product.aaaQtyByDate && product.aaaQtyByDate.length >= 1 ? product.aaaQtyByDate[product.aaaQtyByDate.length - 1][1] : 0,
                    aaaCostPrice: product.aaaCostPrice,
                    aggregated: false
                };
            }
        });

        return aggregatedStock;
    }






    return <SalesSummaryModalView
        selectedSales={selectedSales}
        selectedStock={selectedStock}
        brand={brand}
        setShowSalesModal={setShowSalesModal}
        setSelectedSales={setSelectedSales}
        setSelectedStock={setSelectedStock}
        stateStockTable={stateStockTable}
        stockArray={stockArrayState}
        requestSort={requestSort}
        totals={totals}
    />

};

export default SalesSummaryModal;
